import styled from 'styled-components/macro';
import colors from 'Application/theme/colors';

const H3 = styled.h3`
	margin-top: 0;
	margin-bottom: 16px;
	color: ${colors.text.primary};
	font-weight: bold;
	font-size: 20px;
	line-height: 24px;
	text-align: center;
	text-transform: uppercase;
`;

export default H3;
